export enum ContentRecommendationUserAction {
  Dismissed = 1,
  OpenApplicationInStore,
  DirectInstallApplication,
  IgnoredByLaunchingGame,
  Timeout,
  TurnOffNotificationsRequested,
  NotificationSettingsOpened,
  OpenExternalUrl,
  DownloadExternalApp,
  CancelDownloadExternalApp,
  CloseClickedWhileDownloadingExternalApp,
  ForceClosed,
}
